module.exports = __webpack_public_path__ + "img/petstairs24.ea58d4b9.jpg";